import { render } from "./recording.vue?vue&type=template&id=135153aa"
import script from "./recording.vue?vue&type=script&lang=js"
export * from "./recording.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__